import { Component, OnDestroy, OnInit } from '@angular/core';
import { CoursesV1Service } from '../../../_generated/hka-app-service/api/coursesV1.service';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { debounceTime, map, take, tap } from 'rxjs/operators';
import type { GetCourseDto } from '../../../_generated/hka-app-service/model/getCourseDto';

@Component({
  selector: 'app-courses-overview',
  templateUrl: './courses-overview.component.html',
  styleUrls: ['./courses-overview.component.scss']
})
export class CoursesOverviewComponent implements OnInit, OnDestroy {
  public pageTitle: string = 'Studiengänge';
  public loading = true;
  public displayedCourses: BehaviorSubject<GetCourseDto[]> = new BehaviorSubject<GetCourseDto[]>([]);
  public filter: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public courseSubscription: Subscription;

  constructor(private readonly _courseServiceV1: CoursesV1Service) {
    this.courseSubscription = combineLatest([
      this._courseServiceV1.getAllCourses1().pipe(
        take(1),
        map((courses) =>
          courses
            .map((course) => ({
              ...course,
              semesters: course.semesters
                .map((sem) => ({
                  ...sem,
                  name: sem.name.substring(sem.name.indexOf('.') + 1).replace(/\./g, ' ')
                }))
                .sort((a, b) => a.semesterNumber - b.semesterNumber)
            }))
            .sort((a, b) => a.name.localeCompare(b.name))
        )
      ),
      this.filter.asObservable().pipe(debounceTime(200))
    ])
      .pipe(
        map(([courses, filter]) => {
          return filter !== ''
            ? courses.filter((course) => {
                return (
                  course.id.toString().toLowerCase().match(filter.toLowerCase()) ||
                  course.name.toLowerCase().match(filter.toLowerCase())
                );
              })
            : courses;
        }),
        tap(() => (this.loading = false))
      )
      .subscribe(this.displayedCourses);
  }

  public ngOnInit(): void {}

  public onSearch(text: string): void {
    this.filter.next(text);
  }

  ngOnDestroy() {
    this.courseSubscription.unsubscribe();
  }
}
